/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type PlatformCell_ConfigurationFragment = { __typename: 'ConfigurationModel', id: string, platform: string };

export const PlatformCell_ConfigurationFragmentDoc = gql`
    fragment PlatformCell_configuration on ConfigurationModel {
  id
  platform
}
    `;